import {useState, useEffect} from 'react';
import {addRecipeToFavorites, removeRecipeFromFavorites, getFavoriteRecipes} from '../RecipeDB/recipeService';

export const useFavoriteRecipes = (userId) => {
  const [favoriteRecipesIds, setFavoriteRecipesIds] = useState([]);

  useEffect(() => {
    if (!userId) return;
    getFavoriteRecipes(userId).then(favs =>
      setFavoriteRecipesIds(favs.map(r => r.id || r.objectID))
    );
 }, [userId]);

  const addToFavorites = async (recipe) => {
    await addRecipeToFavorites(userId, recipe);
    setFavoriteRecipesIds(prev => [...prev, recipe.id || recipe.objectID]);
 };

  const removeFromFavorites = async (recipe) => {
    await removeRecipeFromFavorites(userId, recipe);
    setFavoriteRecipesIds(prev => prev.filter(id => id !== (recipe.id || recipe.objectID)));
 };

  return {favoriteRecipesIds, addToFavorites, removeFromFavorites};
};